<template>
  <a :href="document.file" target="_blank" class="document">
    <div class="document__icon">
      <div class="icon">PDF</div>
    </div>
    <div class="document__content">
      <div class="document__info">
        <p class="document__name">
          {{ document.name }}
        </p>
      </div>
    </div>
  </a>
</template>

<script setup>
const { document } = defineProps({
  document: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss">
@use '@styles/components/pages/project/document.scss' as *;
</style>
